import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function AppFooter() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              Kakobuy Finds Beauty
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Your independent resource for Kakobuy Spreadsheet discoveries, shopping guides and curated product finds. Helping smart shoppers research better.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-800 text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                >
                  Kakobuy Sheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                >
                  Buy It Now
                </a>
              </li>
              <li>
                <Link
                  to="/kakobuy-spreadsheet-guide"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                >
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/kakobuy-safety-guide"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                >
                  Safety Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-800 text-sm mb-4">Browse Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-800 text-sm mb-4">SEO Guides</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/kakobuy-shoes-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                  Shoes Spreadsheet
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-hoodies-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                  Hoodies Guide
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-fashion-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                  Fashion Guide
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-shopping-tips" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                  Shopping Tips
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet-comparison" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                  Comparison Guide
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Kakobuy Finds Beauty. An independent research resource. Not affiliated with any platform.
          </p>
          <p className="text-xs text-foreground-400">
            For informational purposes only.
          </p>
        </div>
      </div>
    </footer>
  );
}